import type { ProposalStatus } from './proposals';

export const proposalStatusStyles: Record<ProposalStatus, string> = {
  'In review': 'border-transparent bg-muted text-muted-foreground',
  Shortlisted: 'border-transparent bg-blue-500/15 text-blue-700 dark:text-blue-400',
  Winner: 'border-transparent bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
  'Not selected': 'border-transparent bg-zinc-500/15 text-zinc-600 dark:text-zinc-400',
};

export const proposalStatuses: ProposalStatus[] = [
  'In review',
  'Shortlisted',
  'Winner',
  'Not selected',
];

export const proposalFilters: Array<'All' | ProposalStatus> = ['All', ...proposalStatuses];
